import Immutable from 'immutable';
import { TAB_SUBMIT, SET_FORM_SUBMITTING, GET_MY_TABS, CLEAR_TAB_RESPONSE, GET_TAB, CLEAR_TAB, GET_ARTIST_TABS, CLEAR_ARTIST_TABS, GET_ARTIST_BY_LETTER, CLEAR_ARTIST_BY_LETTER } from './../actions/tabActions';

const defaultState = Immutable.fromJS({
    tabErrors: null,
    tabResponse: null,
    formSubmitting: false,
    myTabs: null,
    tab: null,
    artistTabs: null,
    artistsByLetter: null,
});

const tab = (state = defaultState, action) => {
  let newState;

  switch (action.type) {
    case SET_FORM_SUBMITTING:
        newState = state.set('formSubmitting', true);
      break;
    case GET_MY_TABS:
        newState = state.set('myTabs', action.data);
      break;
    case GET_TAB:
      newState = state.set('tab', action.data);
    break;  
    case CLEAR_TAB:
      newState = state.set('tab', null);
    break;  
    case GET_ARTIST_TABS:
      newState = state.set('artistTabs', action.data);
    break;  
    case CLEAR_ARTIST_TABS:
      newState = state.set('artistTabs', null);
    break;  
    case GET_ARTIST_BY_LETTER:
      newState = state.set('artistsByLetter', action.data);
    break;  
    case CLEAR_ARTIST_BY_LETTER:
      newState = state.set('artistsByLetter', null);
    break;  
    case TAB_SUBMIT:
        if(action.errors !== null)
        {
            newState = state.set('tabErrors', action.errors).set('tabResponse', null).set('formSubmitting', false);
        }
        else
        {
            newState = state.set('tabErrors', null).set('tabResponse', action.data).set('formSubmitting', false);
        }
      break;
    case CLEAR_TAB_RESPONSE:
            newState = state.set('tabResponse', null);
        break;

    default:
      newState = state;
  }

  return newState;
};

export default tab;



// WEBPACK FOOTER //
// ./src/reducers/tab.js